export default __webpack_public_path__ + "static/media/favicon.9db52431.ico";